import {INITIALIZE_DROPDOWNTYPE_DROPDOWN,
    GET_DROPDOWN_LIST_BY_TYPE,
    ADD_DROPDOWN_DATA,
    HANDLE_EDITABLE_ROW_ID,
    UPDATE_DROPDOWN_DATA_FIELDS,
    SAVE_DROPDOWN_VALUE,
    SET_DROPDOWN_TYPE,  
    HANDLE_CANCEL,
    SET_ACTIVE_PAGE,
    CLEAR_DATA
} from '../actions/index'

const initialState = {
    dropDownListByType:[],
    dropDownTypes:[],
    totalRecordCount:0,
    editableRowId:null,
    dropDownType:'',
    page:1
}


export default function ManageDropdownReducer(state=initialState, action){

    switch(action.type){

      case INITIALIZE_DROPDOWNTYPE_DROPDOWN :{

        const {payload} = action
        return {
            ...state,
            dropDownTypes:payload,
        }

      }

      case GET_DROPDOWN_LIST_BY_TYPE:{
        const {dropDownListByType,totalRecordCount} = action.payload
        return {
            ...state,
            dropDownListByType:dropDownListByType,
            totalRecordCount:totalRecordCount

        }
      }

        case ADD_DROPDOWN_DATA:{
            const {payload} = action
            return {
                ...state,
                dropDownListByType:[payload,...state.dropDownListByType],
                editableRowId:payload.id
            }

        }
        case UPDATE_DROPDOWN_DATA_FIELDS:{
            const {id,payload} = action
            const index = state.dropDownListByType.findIndex(item=>item.id===id)
            const temp=[...state.dropDownListByType]
            temp[index] ={...temp[index],...payload}
        
            return {
                ...state,
                dropDownListByType:temp
            }
        }
        case HANDLE_EDITABLE_ROW_ID:{
            const {payload} = action
            return {
                ...state,
                editableRowId:payload
            }
        }

        case HANDLE_CANCEL :{
            let temp = state.dropDownListByType;
            let res =  temp.slice(1)
            return {
                ...state,
                dropDownListByType:res
            }

        }

        case SAVE_DROPDOWN_VALUE:{
            const {payload} = action
            let temp = state.dropDownListByType;
            temp[0] = payload
            return {
                ...state,
                dropDownListByType:temp,
                editableRowId:null
            }
        }

        case SET_DROPDOWN_TYPE:{
            const {payload} = action
            return {
                ...state,
                dropDownType:payload,
                page:1
            }
        }

        case SET_ACTIVE_PAGE:{
            const {payload} = action
            return {
                ...state,
                page:payload
            }
        }

        case CLEAR_DATA:{
            return initialState
        }

        default :
        return state;

    }

}